export enum DRAWER_CONTEXT {
  CREATE_PRODUCT = 'CREATE_PRODUCT',
  EDIT_PRODUCT = 'EDIT_PRODUCT',
  CREATE_LOCATION = 'CREATE_LOCATION',
  EDIT_LOCATION = 'EDIT_LOCATION',
  CREATE_STOCK = 'CREATE_STOCK',
  EDIT_STOCK = 'EDIT_STOCK',
  CREATE_BUNDLE = 'CREATE_BUNDLE',
  EDIT_BUNDLE = 'EDIT_BUNDLE',
  CREATE_TRADE = 'CREATE_TRADE',
  EDIT_TRADE = 'EDIT_TRADE',
  CREATE_TAG = 'CREATE_TAG',
  EDIT_TAG = 'EDIT_TAG',
  CREATE_STAGE = 'CREATE_STAGE',
  EDIT_STAGE = 'EDIT_STAGE',
}
